import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  useRecordContext,
  TopToolbar,
  ListButton,
} from 'react-admin';
import { Card, CardContent, Grid, Typography, Box } from '@mui/material';
import { ActionChip } from '../../components/settings/ActionChip';
import { JSONDiffViewer } from '../../components/settings/JSONDiffViewer';

interface AuditLog {
  id: number;
  admin_user_id: number;
  admin_username?: string;
  admin_email?: string;
  action: string;
  resource_type: string;
  resource_id?: number;
  changes?: Record<string, any>;
  ip_address?: string;
  user_agent?: string;
  created_at: string;
}

const AuditLogShowActions = () => (
  <TopToolbar>
    <ListButton />
  </TopToolbar>
);

export const AuditLogShow = () => {
  const record = useRecordContext<AuditLog>();

  return (
    <Show actions={<AuditLogShowActions />}>
      <SimpleShowLayout>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Log Information
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <InfoRow label="ID" value={record?.id} />
                  <InfoRow label="Admin User" value={record?.admin_username} />
                  <InfoRow label="Admin Email" value={record?.admin_email} />
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                      Action:
                    </Typography>
                    {record?.action && <ActionChip action={record.action} />}
                  </Box>
                  <InfoRow label="Resource Type" value={record?.resource_type} />
                  <InfoRow
                    label="Resource ID"
                    value={record?.resource_id || 'N/A'}
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Metadata
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <InfoRow
                    label="IP Address"
                    value={record?.ip_address || 'N/A'}
                  />
                  <InfoRow
                    label="User Agent"
                    value={record?.user_agent || 'N/A'}
                  />
                  <InfoRow
                    label="Time"
                    value={
                      record?.created_at
                        ? new Date(record.created_at).toLocaleString()
                        : 'N/A'
                    }
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Changes
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <JSONDiffViewer changes={record?.changes || {}} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

const InfoRow = ({ label, value }: { label: string; value: any }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
    <Typography variant="body2" color="text.secondary">
      {label}:
    </Typography>
    <Typography variant="body2" fontWeight="bold">
      {value}
    </Typography>
  </Box>
);
